"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _applyStyles = _interopRequireDefault(require("./applyStyles.js"));
//@ts-check

/**
 * @typedef {object} StyleInputProps
 * @property {string} className
 * @property {object} style
 * @property {object|object[]} styles
 * @property {number} [styleOrder]
 */

/**
 * @typedef {object} StyleProps
 * @property {string} [className=null]
 * @property {object} [style=null]
 */
/**
 * @param {StyleInputProps} props
 * @returns {StyleProps}
 */
var bindStyles = function bindStyles(_ref) {
  var className = _ref.className,
    style = _ref.style,
    styles = _ref.styles,
    styleOrder = _ref.styleOrder;
  /**
   * @type {{className?:string, style?: React.CSSProperties}}
   */
  var newStyleProps = {
    className: className,
    style: style
  };
  (0, _applyStyles["default"])(newStyleProps, styles, styleOrder);
  if (!newStyleProps.className) {
    delete newStyleProps.className;
  }
  if (!newStyleProps.style) {
    delete newStyleProps.style;
  }
  return newStyleProps;
};
var _default = exports["default"] = bindStyles;
module.exports = exports.default;